'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const TaskAPI = require('communication/infra/api/task/index');
const TaskFactory = require('communication/domain/factory/task');
const TaskCollection = require('communication/domain/collection/task');

class Repository {
    constructor(project) {
        _.extend(this, Backbone.Events);

        this._project = project;
        this._tasks = new Backbone.Collection();
    }

    getTaskByID(id) {
        return this._tasks.get(id);
    }

    fetchTaskByID(id) {
        return new Promise((resolve, reject) => {
            let task = this.getTaskByID(id);
            if(task) {
                resolve(task);
                return;
            }

            return TaskAPI.getByID(this._project.id, id, {noRaise: true})
                .then(json => {
                    if (!json) {
                        // noRaise: true にしているので、 NotFound の時には json が undefined で渡ってくることがある
                        // その時には、 null を返す
                        return null;
                    }
                    return this.build(json);
                })
                .then(task => {
                    if (task) {
                        resolve(this.add(task));
                    } else {
                        resolve(null);
                    }
                }, reject);
        });
    }

    fetchByKey(key, limit=10, cursor=null) {
        let pagination;
        return TaskAPI.getNextByRelatedKey(this._project.id, key, limit, cursor)
            .then(taskData => {
                const tasksJSON = taskData.results;
                pagination = taskData.pagination;

                return Promise.all(
                    _.map(tasksJSON, j => {
                        return this.build(j);
                    })
                )
            }).then(tasks => {
                tasks = this._tasks.add(tasks, {merge: true});

                return {
                    models: tasks,
                    pagination: pagination
                };
            });
    }

    // key に変更
    add(task, options) {
        const trigger = !this._tasks.get(task.id);
        task = this._tasks.add(task, {merge: true});

        if(trigger) {
            this.trigger('add', task);

            if(options && options.addCount) {
                this.trigger('add:count', task);
            }
        } else {
            this.trigger('update', task);
        }

        return task;
    }

    build(json) {
        return new TaskFactory(this._project).build(json);
    }
}

const repositories = {};

const find = function(project) {
    let r = repositories[project.id];
    if(!r) {
        r = new Repository(project);
        repositories[project.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./communication/domain/repository/task.js